<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Confirmação do pagamento</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para análise de pagamento.
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="radios-motivos">
            <h4 class="mg-left-16 mg-bottom-24">
              Motivo problema no pagamento
            </h4>

            <div>
              <mat-radio-group
                (ngModelChange)="changeReasonOption()"
                class="radios-btns mg-left-16"
                aria-label="Selecione uma opção"
                [(ngModel)]="reasonRefusalPayment"
              >
                <mat-radio-button value="Cadastro de conta errada">
                  <p class="text-grey-normal">
                    Conta indevida cadastrada (outra titularidade)
                  </p>
                </mat-radio-button>
              </mat-radio-group>

              <div>
                <mat-radio-group
                  (ngModelChange)="changeReasonOption()"
                  class="radios-btns mg-left-16"
                  aria-label="Selecione uma opção"
                  [(ngModel)]="reasonRefusalPayment"
                >
                  <mat-radio-button value="Outros">
                    <p class="text-grey-normal">Outro</p>
                  </mat-radio-button>
                </mat-radio-group>

                <div
                  *ngIf="reasonRefusalPayment === 'Outros'"
                  class="col-md-6 mg-left-13"
                >
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Descreva o motivo </mat-label>
                    <input
                      matInput
                      type="text"
                      [(ngModel)]="descriptionRefusalPayment"
                      (ngModelChange)="onDescriptionChange()"
                      class=""
                      name=""
                      required
                    />
                    <mat-error
                      *ngIf="
                        reasonRefusalPayment === 'Outros' &&
                        descriptionRefusalPayment == ''
                      "
                      >Motivo obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          type="button"
          [style.width]="'134px'"
          class="btn-outline-dark btn"
          (click)="closeModal()"
          type="button"
        >
          Fechar
        </button>
        <button
          type="button"
          class="btn-footer btn btn-dark-primary-blue"
          type="button"
          (click)="reprovePayment()"
          [disabled]="validateDescriptionSend()"
        >
          Confirmar
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </div>
  </div>
</div>
